"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgVote = exports.VoteOption = void 0;
var long_1 = __importDefault(require("long"));
var ow_1 = __importDefault(require("ow"));
var address_1 = require("../../../utils/address");
var typeurl_1 = require("../../common/constants/typeurl");
var ow_types_1 = require("../ow.types");
var legacyAmino = __importStar(require("../../../cosmos/amino"));
var VoteOption;
(function (VoteOption) {
    VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
})(VoteOption = exports.VoteOption || (exports.VoteOption = {}));
exports.msgVote = function (config) {
    return (function () {
        function MsgVote(options) {
            ow_1.default(options, 'options', ow_types_1.owMsgVoteOptions);
            this.proposalId = options.proposalId;
            this.voter = options.voter;
            this.option = options.option;
            this.validate();
        }
        MsgVote.prototype.toRawAminoMsg = function () {
            var aminooption = legacyAmino.VoteOption.VoteOptionUnspecified;
            switch (this.option) {
                case VoteOption.VOTE_OPTION_UNSPECIFIED:
                    aminooption = legacyAmino.VoteOption.VoteOptionUnspecified;
                    break;
                case VoteOption.VOTE_OPTION_YES:
                    aminooption = legacyAmino.VoteOption.VoteOptionYes;
                    break;
                case VoteOption.VOTE_OPTION_ABSTAIN:
                    aminooption = legacyAmino.VoteOption.VoteOptionAbstain;
                    break;
                case VoteOption.VOTE_OPTION_NO:
                    aminooption = legacyAmino.VoteOption.VoteOptionNo;
                    break;
                case VoteOption.VOTE_OPTION_NO_WITH_VETO:
                    aminooption = legacyAmino.VoteOption.VoteOptionNoWithVeto;
                    break;
                default:
                    break;
            }
            return {
                type: 'cosmos-sdk/MsgVote',
                value: {
                    proposal_id: this.proposalId.toString(),
                    voter: this.voter,
                    option: aminooption,
                },
            };
        };
        MsgVote.prototype.toRawMsg = function () {
            var proposal = long_1.default.fromString(this.proposalId.toString(), true);
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.MsgVote,
                value: {
                    proposalId: proposal,
                    voter: this.voter,
                    option: this.option,
                },
            };
        };
        MsgVote.prototype.validate = function () {
            if (!address_1.validateAddress({
                address: this.voter,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `voter` doesnt match network selected');
            }
        };
        return MsgVote;
    }());
};
//# sourceMappingURL=MsgVote.js.map